import React, { useState, useRef } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import userServices from 'services/user'

const RegisterValidationModal = (props) => {
	const close = props.close;

	const validationForm = useRef();

	const [submitting, setSubmitting] = useState(false);
	const [step, setStep] = useState(1);

	const submit = (validationFormData) => {
		if(step === 1) {
			validationForm.current.setForceTouch(false);
			setStep(2);
		}
		else {
			setSubmitting(true);

			userServices.registerCompany({...props.formData, ...validationFormData}).then((payload) => {
				if (payload === 'step-2') {
					props.onSuccess();
					close();
				}
			}).catch((request) => {
			}).finally(() => {
				setSubmitting(false);
			})
		}
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			ref={validationForm}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">İletişim Bilgilerinizi Onaylayın</h1>
				{props.closeBtn}
			</div>

			<div className={'validation-step' + (step === 1 ? ' active' : '')}>
				<div className="modal-content grid-container">
					<div className="row">
						<div className="col">
							<FormInput
								disabled={submitting}
								type="number"
								label="Cep Telefonunuza Gelen Onay Kodu"
								placeholder="Telefonunuza gelen 6 haneli onay kodunu girin."
								maxLength="6"
								name="sms_code"
								validation={{
									required: 'Onay kodunu girmelisiniz.',
									length: ['Onay kodu {length} haneli olmalıdır.', 6],
								}} />
						</div>
					</div>
				</div>

				<div className="modal-controls">
					<Btn
						nude
						disabled={submitting}
						onClick={close}>
						Vazgeç
					</Btn>
					<Btn
						type="submit"
						disabled={submitting}>
						Devam
					</Btn>
				</div>
			</div>

			{step === 2 &&
				<div className="validation-step active">
					<div className="modal-content grid-container">
						<div className="row">
							<div className="col">
								<FormInput
									disabled={submitting}
									type="number"
									label="E-Posta Adresinize Gelen Onay Kodu"
									placeholder="Size e-posta olarak gönderilen onay kodunu girin."
									maxLength="6"
									name="email_code"
									validation={{
										required: 'Onay kodunu girmelisiniz.',
										length: ['Onay kodu {length} haneli olmalıdır.', 6],
									}} />
							</div>
						</div>
					</div>

					<div className="modal-controls">
						<Btn
							nude
							disabled={submitting}
							onClick={() => { setStep(1); }}>
							Geri
						</Btn>
						<Btn
							loading={submitting}
							disabled={submitting}
							type="submit">
							Ödemeyi Kapat
						</Btn>
					</div>
				</div>
			}
		</InputForm>
	)
}

RegisterValidationModal.defaultProps = {
	className: '',
	containerClass: 'modal-register-validation mobile-full',
	name: 'register-validation',
	formData: false,
}

export default RegisterValidationModal